import _ from 'lodash';

function conditionGroupFields(conditionGroups = []) {
  return _.chain(conditionGroups)
    .map('conditions')
    .reduce((lhs, rhs) => _.concat(lhs, rhs), [])
    .map((o) => o.sourceField?.internalName)
    .uniq()
    .value();
}

function conditionsMapping(conditions = []) {
  return _.map(conditions, (item) => ({ ...item, fieldIdName: item.sourceField?.internalName }));
}

function conditionsGroupsMapping(conditionGroups = []) {
  return _.map(conditionGroups, (item) => {
    return { ...item, conditions: conditionsMapping(item.conditions) };
  });
}

/**
 * Helper function to map the form field groups for behaviors
 * @param {Object} payload
 * @returns
 */
export function formFieldBehaviorsMapping({ behaviorCases }) {
  return _.chain(behaviorCases)
    .orderBy(['order'], ['asc'])
    .map((item) => {
      return {
        ...item,
        conditionFields: conditionGroupFields(item.conditionGroups),
        conditionGroups: conditionsGroupsMapping(item.conditionGroups),
      };
    })
    .value();
}
